import { useMessageContext } from 'stream-chat-react';
import { customReactionOptions } from './custom-reaction-options';

export const CustomReactionSelector = () => {
  const { handleReaction } = useMessageContext('useProcessReactions');

  return (
    <div className="bg-background p-2 rounded-full shadow flex items-center gap-2">
      {customReactionOptions.map((c) => {
        const { Component } = c;
        return (
          <div
            key={c.type}
            onClick={(e) => handleReaction(c.type, e)}
            className="w-7 h-7 flex items-center justify-center rounded-full cursor-pointer hover:bg-secondary/20"
          >
            <Component />
          </div>
        );
      })}
    </div>
  );
};
